export const basementDialogues: any[] = [
    {
        id: 1,
        dialogue: [
            `
            Alex: “EMILY!!
<
EMILY WHERE ARE YOU?!?”
<
*You see multiple doors in the basement*
            `,
        ],
        options: [{ id: 1, action: "Try opening the doors", roomId: 9 }],
    },
    {
        id: 2,
        dialogue: [
            `
            Alex: “AH COME ON!!!
<
OPEN UP!!”
<
*You try to open the doors, none of the doors seem to open except for one*
        `,
        ],
        options: [{ id: 1, action: "Enter the unlocked door", roomId: 9 }],
    },
    {
        id: 3,
        dialogue: [
            `
            *You find yourself in a dark room. you can barely see*
<
Alex: “I can barely see anything..
<
*As you keep walking you feel a door in front of you*
        `,
        ],
        options: [
            { id: 1, action: "Enter the door", roomId: 9 },
            { id: 2, action: "Turn on your flashlight (FLASHLIGHT Required)", roomId: 9 },
        ],
    },
    {
        id: 4,
        dialogue: [
            `
            *You rush through the door and find yourself in a hallway, you see light coming from a room at the end of the long hallway*
<
Alex: “EMILY, PLEASE BE OKAY..
<
EMILY!!”
        `,
        ],
        options: [
            { id: 1, action: "Rush towards the lit room", roomId: 9 },
            { id: 2, action: "Proceed carefully", roomId: 9 },
        ],
    },
    {
        id: 5,
        dialogue: [
            `
            *You move towards the end of the hallway*
<
Alex: “AAAAAAAAAAAAAAAAHHHHH!!!
<
MYY LEGGGG!!!”
<
*You look down towards your leg, you see the spikes of a rusty bear trap piercing through the bottom of your leg*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 6,
        dialogue: [
            `
        *You stay on the side of the hallway and proceed carefully,> 
        you come across an entry to what seems to be a tunnel,>
        it's very tight but you think you'll fit through*
        `,
        ],
        options: [
            { id: 1, action: "Proceed to the end of the hallway", roomId: 9 },
            { id: 2, action: "Enter the tunnel", roomId: 9 },
        ],
    },
    {
        id: 7,
        dialogue: [
            `
        *You start to feel lightheaded, your vision is blurry but you noitice a shim walking towards you as you're laying on the ground*
<
Vincent: “You made it far..
<
just not far enough...”
<
Alex: “Wh... what?..”
<
*You lose your consciousness from the pain*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 8,
        dialogue: [
            `
        *You wake up, it seems like you're tied to a chair with your wrists and ancles*
<
Vincent: “Wake up Alex”
<
Alex: “Wh... where am i?..”
<
Vincent: “All this effort you put in.. 
<
well.. it has been all for nothing”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 9,
        dialogue: [
            `
        Alex: “What.. WHAT ARE YOU TALKING ABOUT?!
<
WHERE IS EMILY?!”
<
Vincent: “She's here.. right with us..”
<
Alex: “Wh... what?.. EMILY?!”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 10,
        dialogue: [
            `
        Vincent: “Why don't you look over there”
<
*The person in front of you turns his head towards the left, you follow his lead*
<
Alex: “Wh... w.. EMILY?!
<
EMILY!?!?!?!
<
BABY PLEASE.. WAKE UP.. PLEASE.. EMILY WAKE UP!!!”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 11,
        dialogue: [
            `
        Vincent: “Well.. now you know what it feels like”
<
Alex: “OH GOD.. WHAT DID YOU DO TO HER?!!?!
<
BABY WAKE UP.. PLEASE!!!”
<
Vincent: “She's dead Alex..”
<
Alex: “NOO.... GOD PLEASE NO... WHYY?!?”
<
Vincent: “This is all your own doing Alex”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 12,
        dialogue: [
            `
        Vincent: “But no worries, you will follow her soon”
<
Alex: “I.. wh.. why are you.. doing this?..”
<
Vincent: “All i'm doing is returning the favor...
<
You took everything away from me, and now i'm taking away everything from you.”
<
Alex: “WHAT DID I DO TO YOU? I DON'T EVEN KNOW WHO YOU ARE”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 13,
        dialogue: [
            `
        Vincent: “Yes you don't know me, but you took my whole world away”
<
Alex: “What?.. WHAT DO YOU MEAN?!”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 14,
        dialogue: [
            `
        Vincent: “The accident.. THE FUCKING ACCIDENT.
<
Yeah i bet you know what i'm talking about now.
<
Jane.. Jason.. you killed them. And now nothing matters anymore, 
except for making you feel the pain that i've felt all this time.
”
<
Alex: “I.. it was.. an accide...”
<
Vincent: “Yeah let me stop you right there. That's what we all thought and heard at first. 
Until we got the results of your sobriety test, evidence that was what they called “tainted”. 
That's why you got away with what you did.
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 15,
        dialogue: [
            `
        *You start crying*
<
Alex: “I'm.. i... i'm sorry.. Emily... my baby girl... i...”
<
Vincent: “You killed my beautiful sister and my best buddy.. he was such a great kid.. AND YOU KILLED THEM.
<
Now that you have felt my pain, all of this can end.”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 16,
        dialogue: [
            `
        *As you feel only pain and lose your breath, you feel your consciousness flowing away*
<
Alex: “Emily......”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 20,
        dialogue: [
            `
        *You turn on the flashlight, your vision increases. You notice an entrance to a very tight tunnel*
        `,
        ],
        options: [
            { id: 1, action: "Enter the tunnel", roomId: 9 },
            { id: 2, action: "Enter the door", roomId: 9 },
        ],
    },
    {
        id: 21,
        dialogue: [
            `
        *You pass through the tunnel, which seems to finish towards only one end*
<
Alex: “Please be okay Em..”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 22,
        dialogue: [
            `
        *You step out of the end of the tunnel, you see some light coming from a room, you approach the room carefully*
<
Alex: “Easy now...”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 23,
        dialogue: [
            `
        *You find yourself close to the entrance of the room. 
        As you reach in towards the doorway you hear someone crying inside the room, but it's very silent. 
        You also hear some heavier breathing*
        `,
        ],
        options: [{ id: 1, action: "Enter the room", roomId: 9 }],
    },
    {
        id: 24,
        dialogue: [
            `
        *You quickly get into the room, 
        it's a dark room with only small light bulbs keeping some of the area's lit. 
        You see Vincent in the distance standing at a different entrance to the room.
<
And.. 
<
you see Emily tied to a chair, she seems to be in a very poor condition.*
<
Alex: “EMILY!!”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 25,
        dialogue: [
            `
        *You run towards her, she looks to be okay but seems a little drowsy*
<
Alex: “EMILY!!!”
<
Emily: “Da...... Dad?” 
<
Alex: “Baby... are you okay!?”
<
Vincent: “Well it seems like you made it to the end...”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 26,
        dialogue: [
            `
        *Vincent approaches closer*
<
Alex: “YOU MONSTER.. WHY ARE YOU DOING THIS?!?”
<
Emily: “Da...... Daddy?” 
<
Alex: “It's going to be okay baby...”
<
*You cut Emily loose from the chair with your pocket knife, she throws her arms around you.*
<
Vincent: “You think this is over?.. WE ARE NOT DONE YET.”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 27,
        dialogue: [
            `
        *Vincent approaches even closer, you put Emily behind you and you reach out with your pocket knife's blade pointing towards Vincent*
<
Vincent: “You took my whole world away..
<
The accident.. THE FUCKING ACCIDENT.
<
Yeah i bet you know what i'm talking about now..
”
<
Alex: “Wh... What?..”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 28,
        dialogue: [
            `
        DUPLICATE
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 29,
        dialogue: [
            `
        Vincent: “Jane.. Jason.. you killed them. And now nothing matters anymore, 
        except for making you feel the pain that i've felt all this time.”
<
Alex: “I.. it was.. an accide...”
<
Vincent: “Yeah let me stop you right there. That's what we all thought and heard at first. 
Until we got the results of your sobriety test, evidence that was what they called “tainted”. 
That's why you got away with what you did.
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 30,
        dialogue: [
            `
        *You start thinking of your past*
<
Alex: “I'm.. i... i'm sorry.. Emily... my baby girl... please..”
<
Vincent: “You killed my beautiful sister and my best buddy.. he was such a great kid.. AND YOU KILLED THEM.
<
Now you will feel the pain that i've been feeling all this time..”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 31,
        dialogue: [
            `
        *Vincent reaches in with what seems to be a crowbar*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 32,
        dialogue: [
            `
        Alex: “STOP!! YOU DON'T HAVE TO DO THIS.”
<
*You hear Emily crying behind you*
<
Vincent: “Oh yes.. this is something i will do... for them..”
<
*Vincent takes another swing at you with his crowbar*
        `,
        ],
        options: [
            { id: 1, action: "Step back", roomId: 9 },
            { id: 2, action: "Try to block the swing", roomId: 9 },
            { id: 3, action: "Reach in with the Pocket-knife", roomId: 9 },
        ],
    },
    {
        id: 33,
        dialogue: [
            `
        *You reach in with your pocket knife's blade and cut Vincent in his neck, 
        the crowbar still hits you hard on the ribs.*
<
Alex: “AAAHHHH!!”
<
Vincent: “AHH FUCK!! YOU PIECE OF SHIT!!”
<
*Vincent reaches his hand towards the neck and seems stunned, you start to cough up some blood*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 34,
        dialogue: [
            `
        *You try to block Vincent swinging his crowbar, but you fail. You atleast tried to reach in with your pocket knife's blade and cut Vincent in his neck, the crowbar hits you hard on the ribs.*
<
Alex: “AAAHHHH!!”
<
Vincent: “AHH FUCK!! YOU PIECE OF SHIT!!”
<
*Vincent reaches his hand towards the neck and seems stunned, you start to cough up some blood*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 35,
        dialogue: [
            `
        *You try to step backwards. The crowbar hits you hard on the ribs. 
        While stepping backwards you tried to reach in with your pocket knife's blade and cut Vincent in his neck*
<
Alex: “AAAHHHH!!”
<
Vincent: “AHH FUCK!! YOU PIECE OF SHIT!!”
<
*Vincent reaches his hand towards the neck and seems stunned, you start to cough up some blood*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 36,
        dialogue: [
            `
        Alex: “WE DON'T HAVE TO DO THIS!! ahh...”
<
Vincent: “YES WE DO, FOR JANE.. AND JASON”
<
*Vincent gets closer and reaches in with another swing, you try to counter the swing*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 37,
        dialogue: [
            `
        *Right when Vincent's crowbar hits you, you manage to stab him in the chest with your pocket knife..*
<
Emily: “DAAAAAD!!!!”
<
Alex: “Ah.....”
<
Vincent: “AAAAAAAAHHHHHHHH!!!!!”
<
*Vincent falls down on his back, the knife seems to have hit right in his heart, Vincent has stopped moving completely, Emily runs towards you*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 38,
        dialogue: [
            `
        *You're extremely hurt and can't seem to get up, your vision becomes blurry*
<
Emily: “DAAAD!!!! PLEASE DAD!!!”
<
Alex: “Ba.... Baby.... phone... on the desk... call 911...”
<
*You see Emily running towards the phone. She seems to be calling 911. 
In the distance you hear the 911 operator answering to Emily*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 39,
        dialogue: [
            `
        *As you feel only pain and lose your breath, you feel your consciousness flowing away*
<
Alex: “Emily......”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 50,
        dialogue: [
            `
            *You reach in with your pocket knife's blade and cut Vincent in his neck, the crowbar still hits you hard on the ribs.*
<
            Alex: “AAAHHHH!!”
            <
            Vincent: “AHH FUCK!! YOU PIECE OF SHIT!!”
            <
            *Vincent reaches his hand towards the neck and seems stunned, you start to cough up some blood*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 51,
        dialogue: [
            `
            Alex: “WE DON'T HAVE TO DO THIS!! ahh...”
<
            Vincent: “YES WE DO, FOR JANE.. AND JASON”
            <
            *Vincent gets closer and reaches in with another swing, you try to counter the swing*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 52,
        dialogue: [
            `
            *You see the swing coming in and dodge the attack, you manage to stab him in the chest with your pocket knife..*
<
            Emily: “DAAAAAD!!!!”
            <
            Alex: “Ah.....”
            <
            Vincent: “AAAAAAAAHHHHHHHH!!!!!”
            <
            *Vincent falls down on his back, the knife seems to have hit right in his heart, Vincent has stopped moving completely, Emily runs back towards you*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 53,
        dialogue: [
            `
            Emily hugs you around the legs, you feel hurt.
<
            Alex: “Em... it's all over now baby... it's all over..”
            <
            *Emily starts crying, you wrap your arms around her*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 54,
        dialogue: [
            `
            *You scan the room and notice a telephone on a desk in the corner of the room, you start calling 911*
<
            Alex: “We're going to be okay Em..”
           < 
            *Emily holds on to you tight*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 60,
        dialogue: [
            `
            *You try to block Vincent swinging his crowbar, but you fail. 
            You atleast tried to reach in with your pocket knife's blade and cut Vincent in his neck, the crowbar hits you hard on the ribs.*
<
            Alex: “AAAHHHH!!”
            <
            Vincent: “AHH FUCK!! YOU PIECE OF SHIT!!”
            <
            *Vincent reaches his hand towards the neck and seems stunned, 
            you start to cough up some blood*
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
    {
        id: 98,
        dialogue: [
            `THE END
            <
            PRESS CONTINUE TO RESTART THE GAME.
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 9 }],
    },
];
